import { css } from '@emotion/core'
import { Color } from 'csstype'

export default (color: Color) =>
  css`
    filter: drop-shadow(0 0.08rem 0.1rem ${color});
  `
